(function () {
    'use strict';

    angular
        .module('app.settings')
        .controller('SettingsController', Controller);

    Controller.$inject = ['$scope', '$location', 'SettingsService', 'NgTableParams', 'GeneralService'];

    function Controller($scope, $location, SettingsService, NgTableParams, GeneralService) {
        var vm = this;

        activate();

        function activate() {
            vm.firstLoad = true;
            vm.tableParams = new NgTableParams(
                angular.extend({ page: 1, count: 10 }, $location.search()),
                {
                    getData: function (params) {
                        if (!vm.firstLoad) {
                            $location.search(params.url());
                        }
                        vm.firstLoad = false;
                        var filterData2 = params.filter();
                        var filterData = {};
                        filterData.PageIndex = params.page(),
                            filterData.PageSize = params.count(),
                            filterData.SortProperty = Object.keys(params.sorting())[0],
                            filterData.SortType = params.sorting()[Object.keys(params.sorting())[0]];
                        var keys = Object.keys(filterData2);
                        for (var i = 0; i < keys.length; i++) {
                            filterData[keys[i]] = filterData2[keys[i]];
                        }
                        return SettingsService.getAll(filterData).then(function (data) {
                            params.total(data.FilteredCount);

                            return data.Data;
                        });
                    }
                });
        }

        vm.cancel = cancel;
        vm.save = save;
        vm.add = add;

        ///////////////////////////////////

        vm.shutdown = function () {
            vm.loading = true;
            GeneralService.shutdown()
                .then(function () {
                    vm.loading = false;
                });
        };

        function cancel(row, rowForm) {
            vm.tableParams.reload();
        }

        function save(row, rowForm) {
            if (row.Id) {
                SettingsService.edit(row).then(function (data) {
                    vm.tableParams.reload();
                });
            } else {
                SettingsService.add(row).then(function (data) {
                    vm.tableParams.reload();
                });
            }
        }

        function add() {
            vm.tableParams.data.unshift({
                Name: "",
                isEditing: true
            });
        }
    }
})();